/** Fired by App on idle/manual logout so an in-flight tour cannot stick on the sign-in screen. */
export const TOUR_AUTH_LOGOUT_EVENT = 'xspectre:auth-logout';

const HANDOFF_VEIL_ID = 'xspectre-tour-handoff-veil';

/**
 * Full-screen dim kept between section tours so Next section does not flash
 * the undimmed dashboard while the next page mounts.
 */
export function mountTourHandoffVeil() {
  if (typeof document === 'undefined') return null;
  let veil = document.getElementById(HANDOFF_VEIL_ID);
  if (!veil) {
    veil = document.createElement('div');
    veil.id = HANDOFF_VEIL_ID;
    veil.className = 'xspectre-tour-handoff-veil';
    veil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(veil);
  }
  return veil;
}

export function removeTourHandoffVeil() {
  if (typeof document === 'undefined') return;
  document.getElementById(HANDOFF_VEIL_ID)?.remove();
}

/**
 * Remove leftover driver.js chrome from document.body.
 * Driver mounts outside React, so unmount alone is not enough if an async step
 * recreates the overlay after destroy, or logout tears down the dashboard mid-step.
 */
export function forceRemoveDriverDom() {
  if (typeof document === 'undefined') return;
  document
    .querySelectorAll(
      '.driver-popover, .driver-overlay, .driver-active-element, #driver-dummy-element, .driver-stage'
    )
    .forEach((node) => {
      try {
        node.remove();
      } catch (_) {
        /* ignore */
      }
    });
  document.body?.classList?.remove('driver-active', 'driver-fade', 'driver-no-interaction');
  document.documentElement?.classList?.remove('driver-active', 'driver-fade', 'driver-no-interaction');
}
